import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_storage_category_rulesService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: {  }): 
  Promise<{ result: { Id?: number, Name?: string, RuleLines?: { Id?: number, ExpirationRate?: number, Priority?: number, WarehouseId?: number, StorageCategory?: { Id?: number, LookupCode?: string } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_storage_category_rules/get`;
    
    const options = {
    }
    
    const body = null;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, RuleLines?: { Id?: number, ExpirationRate?: number, Priority?: number, WarehouseId?: number, StorageCategory?: { Id?: number, LookupCode?: string } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_storage_category_rules/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, RuleLines?: { Id?: number, ExpirationRate?: number, Priority?: number, WarehouseId?: number, StorageCategory?: { Id?: number, LookupCode?: string } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_storage_category_rules/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
